<div class="custom-checkbox" [formGroup]="formGroup" [ngClass]="{
  error:
    !formGroup.controls[formControlName].valid,
  small: type === 'small'
}">
  <label class="label-container">
    <input type="checkbox" [formControlName]="formControlName">
    <span class="custom-checkbox-btn"></span>
    @if (!labelHTML) {
      <span class="label">{{label}}</span>
    }
    @if (labelHTML) {
      <div class="cs-inner-html-checkbox" [innerHTML]="labelHTML"></div>
    }
  </label>
  <span class="error-message">*This box must be checked to continue</span>
</div>
